import React, {useState, useEffect, useRef} from 'react';
import { Modal as ModalComponent, closeModal } from '../../common/Modal.jsx';
import Errors from '../../common/Errors.jsx';
import { Portal } from '../../common/Portal.jsx';
import Select from '../../common/Select.jsx';
import {LinkToModal} from '../../common/LinkToModal.jsx';
import ToggleSwitch from "../../common/ToggleSwitch.jsx";

import {
  project_report_compare_submissions_path,
  project_report_list_json_legacy_path,
  project_report_preview_path
} from '~/routes';

const MODAL_ID = 'compare-submissions-modal';

export const CompareSubmissionsModal = ({handleCloseModal, setBtnLabel, setCompare, setSelectedData, selectedData, previousVersions, differentSubmissions, monitoring_report_id, project_id, project_report_id}) => {
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);
  const formRef = useRef();

  const handleClose = () => {
    closeModal(MODAL_ID);
    handleCloseModal();
  };

  // const toggleHighlight = () => {
  //   let diffs = $('.diff-content');
  //   if(!$('#react-toggle-compare-control').is(':checked')) diffs.toggleClass('diff-content');
  //
  //   $('#react-toggle-compare-control').off('change').on('change', function () {
  //     diffs.toggleClass('diff-content')
  //   });
  // };

  const reSetBtnLabel = (formData) => {
    var selectedOption = null;
    setCompare(false);

    if(formData.version)
      selectedOption = previousVersions.find(o => o.value == formData.version)?.label;

    else if(formData.different_submission)
      selectedOption = differentSubmissions.find(o => o.value == formData.different_submission)?.label;

    else if(formData.pre_filled_values)
      selectedOption = I18n.t('pre_filled_values');

    setBtnLabel(selectedOption ? `${selectedOption}` : I18n.t('compare_submission'));
    setCompare(selectedOption != null);
  };

  const submit = (e) => {
    e.preventDefault();
    setSaving(true);

    var formData = $(formRef.current).serializeArray().reduce((map, obj) => (map[obj.name] = obj.value, map), {});
    setSelectedData(formData);

    $.post(project_report_compare_submissions_path({...{monitoring_report_id, project_id, project_report_id}}), formData)
      .done((res) => {
        $('.diff-content').removeClass('diff-content');
        reSetBtnLabel(formData);

        res.forEach(v => {
          $(`[data-form-link-id="${v['form_link_id']}"`).attr('data-diff', JSON.stringify({fields: v['fields'], multivalued_fields: v['multivalued_fields']}));

          var form = $(`.selected[data-form-link-id="${v['form_link_id']}"`);
          if (form.length)
            v['fields'].forEach(k => {
              let multivalued_field = v['multivalued_fields'][k];
              multivalued_field ?
                multivalued_field.forEach(vv => {form.closest('form').find(`[name*="${k}"][value="${vv}"]`).addClass('diff-content')}) :
                form.closest('form').find(`[name*="[${k}"]`).addClass('diff-content')
            });
          //toggleHighlight();
        });

        $('.report-form-wrapper').off('DOMSubtreeModified').on('DOMSubtreeModified', function() {
          var form = $('.selected[data-diff]');
          var data = JSON.parse(form.attr('data-diff'));
          data['fields'].forEach(k => {
            let multivalued_field = data['multivalued_fields'][k];
            multivalued_field ?
              multivalued_field.forEach(vv => {form.closest('form').find(`[name*="${k}"][value="${vv}"]`).addClass('diff-content')}) :
              form.closest('form').find(`[name*="[${k}"]`).addClass('diff-content')
          });
          //toggleHighlight();
        });

        setErrors([]);
        handleClose();
      })
      .fail((res) => {
        let responseJSON = res.responseJSON ? res.responseJSON.errors : {server: [{message: I18n.t('unexpected_error')}]};
        setErrors(responseJSON);
      });

    setSaving(false);
  };

  return (
      <Portal
        id={MODAL_ID}
        size='md'
        title={I18n.t('choose_submission_to_compare_changes')}
        saveLabel={I18n.t('compare_submission')}
        cancelLabel={I18n.t('close')}
        onClose={handleClose}
        onSave={submit}
        saving={saving}
        component={ModalComponent}
      >
        <>
          <Errors errors={errors}/>

          <form ref={formRef} onSubmit={submit}>
            <div className="form-group">
              <label>{I18n.t('previous_version_submission')}</label>
              <Select
                name='version'
                options={previousVersions}
                defaultValue={selectedData.version}
                isClearable={true}
                isDisabled={selectedData.different_submission || selectedData.pre_filled_values || previousVersions.length == 0}
                onChange={(val) => setSelectedData(() => ({version: val}))}
                placeholder={<div>{I18n.t(previousVersions.length == 0 ? 'none_available' : 'react_select_placeholder')}</div>}
              />
            </div>

            <div className='form-group'>
              <label>{I18n.t('different_submission')}</label>
              <Select
                name='different_submission'
                options={differentSubmissions}
                defaultValue={selectedData.different_submission}
                isClearable={true}
                isDisabled={selectedData.version || selectedData.pre_filled_values || differentSubmissions.length == 0}
                onChange={(val) => setSelectedData(() => ({different_submission: val}))}
                placeholder={<div>{I18n.t(differentSubmissions.length == 0 ? 'none_available' : 'react_select_placeholder')}</div>}
              />
            </div>

            <div className='form-group'>
              <input
                type='checkbox'
                name='pre_filled_values'
                id='pre_filled_values'
                value={'true'}
                defaultChecked={selectedData.pre_filled_values}
                disabled={(selectedData.version || selectedData.different_submission)}
                onChange={e => setSelectedData(() => ({pre_filled_values: e.target.checked ? 'true' : ''}))}
              />
              <label htmlFor='pre_filled_values'>&nbsp;{I18n.t('compare_with_pre_filled_values')}</label>
            </div>
          </form>

          <div>{I18n.t('alert_submission_to_compare_changes')}</div>
        </>
      </Portal>
  );
};

const CompareSubmissionsButton = ({monitoring_report_id, project_id, project_report_id, previous_versions = []}) => {
  const [openModal, setOpenModal] = useState(false);
  const [compare, setCompare] = useState(false);
  const [btnLabel, setBtnLabel] = useState(I18n.t('compare_submission'));

  const previousVersions = previous_versions.map(v => ({value: `${v[0]}`, label: `V${v[0]} - ${v[1]}`}));

  const [differentSubmissions, setDifferentSubmissions] = useState([]);
  const [loadDifferentSubmissions, setLoadDifferentSubmissions] = useState(true);

  const [selectedData, setSelectedData] = useState({});

  // handle onClose event of the modal
  const handleCloseModal = () => setOpenModal(false);

  // handle onClick event of the dropdown
  const handleClick = () => setOpenModal(true);

  // handle onClose event of the modal
  const closeCompareMode = () => {
    setCompare(false);
    $('.diff-content').removeClass('diff-content');
  };

  useEffect(() => {
    if (loadDifferentSubmissions) {
      let statuses = ['approved', 'rejected', 'pending_approval', 'pending_reject', 'pending_review'];
      $.post(
        project_report_list_json_legacy_path({monitoring_report_id: monitoring_report_id, project_id: project_id, exists: true}), {statuses: statuses}, (res) => {
          setDifferentSubmissions(res.filter(v => project_report_id != v.project_report_id).map(v => ({value: `${v.project_report_id}`, label: `${v.name[I18n.locale]} - ${I18n.t(`project_report_current_status_${v.current_status}`)} - ${v.formatted_submission_at}`})));
          setLoadDifferentSubmissions(false);
        }
      );
    }
  }, [loadDifferentSubmissions]);

  return (<>
    { compare ?
      <span>
        <LinkToModal
          href={project_report_preview_path({
            project_id: project_id,
            report_id: monitoring_report_id,
            project_report_id: selectedData.different_submission || project_report_id,
            version: selectedData.version,
            pre_filled_values: selectedData.pre_filled_values
            })}
            options={{ title: btnLabel, buttons: false, size: 'lg modal-background-scrolling', style: 'float: right; right: 14%; overflow-y: auto; height: 100%;'}}
            className='btn btn-sm btn-link pull-left'>{btnLabel}
        </LinkToModal>

        <button
          type='button'
          className='btn btn-sm btn-default pull-right'
          onClick={closeCompareMode}>{I18n.t('close_compare_mode')}
        </button>
      </span>
      :
      <button
        type='button'
        className='btn btn-sm btn-default pull-right'
        onClick={handleClick}>{I18n.t('compare_submission')}
      </button>
    }

    {openModal && <CompareSubmissionsModal {...{handleCloseModal, setBtnLabel, setCompare, selectedData, setSelectedData, previousVersions, differentSubmissions, monitoring_report_id, project_id, project_report_id}}></CompareSubmissionsModal>}
  </>);
};

export default CompareSubmissionsButton;
